import React, { useState } from "react";
import Navbar from "./Navbar";

export default function Textform(props) {
  const [Mode, setMode] = useState("lite");

  const handleUpClick = () => {
    //  let newText =text.toUpperCase();
    //  setText(newText);

    var txt = document.querySelector(".form-control");
    txt.select();
    navigator.clipboard.writeText(txt.value);
  };
  const handleapClick = () => {
    //   setMode({
    //    color: 'white',
    //    backgroundColor: 'black'

    //  });
    let newText = text.split(/[ ]+/);
    setText(newText.join(" "));
  };
  const removeCom = () => {
    
    // let newText = text.split(/[ ]+/);
    // setText(newText.join(" "));
    let str = "";
    // const newText = text + '\n';
    // setText(newText)
    for (let i = 0; i < text.length; i++) {
      if (text[i] === "/" && text[i + 1] === "/") {
        let j = i + 2;
        if (i - 1 > -1) {
          if (text[i - 1] === "\n") {
            while (text[j] !== "\n") {
              if (j == text.length) {
                break;
              }
              j++;
            }
            i = j;
          } else {
            while (text[j] !== "\n") {
              // console.log(j);
              if (j == text.length) {
                break;
              }
              j++;
            }
            i = j - 1;
          }
        } else {
          while (text[j] !== "\n") {
            if (j == text.length) {
              break;
            }
            j++;
          }
          i = j;
        }
      } else if (text[i] === "/" && text[i + 1] === "*") {
        let k = i + 2;
        while (text[k] !== "*" && text[k + 1] !== "/") {
          k++;
        }
        i = k + 1;
      } else {
        str += text[i];
      }
    }
    setText(str);
  };

  const toggle = () => {
    if (Mode.color === "white")
      setMode({
        color: "white",
        backgroundColor: "black",
      });
    else {
      setMode({
        color: "white",
        backgroundColor: "black",
      });
    }
  };
  const handleOnChange = (event) => {
    console.log("on change");
    setText(event.target.value);
  };
  const [text, setText] = useState("");

  return (
    <>
      <h1 style={props.Mode}>{props.heading}</h1>
      <div style={props.Mode}>
        <div className=" mb-3" style={props.Mode}>
          {/* <label for="myBox" className='form-label'>TextTool</label> */}
          <textarea
            className="form-control"
            id="mybox"
            style={{
              backgroundColor:
                props.Mode.color === "rgb(5 28 52)" ? "white" : "rgb(7 40 75)",
              color:
                props.Mode.color === "rgb(5 28 52)" ? "rgb(7 40 75)" : "white",
            }}
            value={text}
            onChange={handleOnChange}
            rows="9"
          >
            {text}
          </textarea>
        </div>
        <button className="btn btn-primary mx-1 my-1" onClick={removeCom}>
          {" "}
          Remove Comments
        </button>
        <button className="btn btn-primary mx-1 my-1" onClick={handleapClick}>
          Remove Extra Space
        </button>
        <button className="btn btn-primary mx-1 my-1" onClick={handleUpClick}>
          Copy Text
        </button>
      </div>

      <h1 style={props.Mode}>Text Summary </h1>
      <p style={props.Mode}>
        {text.split(" ").filter((t) => t === " ").length} words {text.length}{" "}
        characters
      </p>
      <p style={props.Mode}>
        {0.009 * text.split(" ").filter((t) => t === " ").length} Minutes  read
      </p>
      <h2 style={props.Mode}>Preview </h2>
      <p style={props.Mode}>
        {text.split(" ").filter(t => t === " ").length <=0
          ? text
          : text }
      </p>
    </>
  );
}
